import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import _ from 'lodash';
import { User } from 'src/app/shared/models/user';
import { AppConstant } from 'src/app/shared/constants/app.constant';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LogoutModalComponent } from '../logout-modal/logout-modal.component';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {

  menu: string;
  address_book: boolean;
  retail_ops: boolean;
  data: any = {};
  user: User;
  private _timeoutId;

  readonly ROLE = AppConstant.ROLE;

  constructor(
    private router: Router,
    private modalService: BsModalService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    const x = this.router.url;
    if (x === '/cit/dashboard') {
      this.menu = 'dashboard';
    }

        /** if 6 hours inactivity auto logout when the browser is closed */
        if (this.isOverdueTime) {
          return (this.logout());
        }

        if (this.authService.isAuthenticated()) {
          this.checkUserActive();
        }

    }
    /** check if user have inactive promp */
    checkUserActive() {
      this._timeoutId = setTimeout(() => {
        this.modalService
          .show(LogoutModalComponent, {
            ignoreBackdropClick: true,
          })
          .content.onClose.pipe(
            tap((res) => console.log(res)),
            tap(({ logout }) => (logout == true ? this.logout() : this.reStartActivity())),
          )
          .subscribe();
      }, AppConstant.ACTIVITY_TIME_OUT);
    }

    reStartActivity(): void {
      this.activityTimes();
      clearTimeout(this._timeoutId);
      this.checkUserActive();
    }



    logout(): void {
      this.authService.logout();
    }

    ngOnDestroy() {
      clearTimeout(this._timeoutId);
      this.activityTimes();
    }

    /** track user activity */
    @HostListener('mousemove') refresh() {
      if (!this.isOverdueTime) {
         this.activityTimes();
      }
      if (this._timeoutId) {
        clearTimeout(this._timeoutId);
        this.checkUserActive();
      }
    }


    get isOverdueTime(): boolean {
      const activity = localStorage.getItem('activityLog');
      if (!activity) {
        this.activityTimes();
        return false;
      }
      const { lastActivity } = JSON.parse(activity);
      const due = (this.currentTime - lastActivity);
      if (due-60000 > AppConstant.ACTIVITY_TIME_OUT) {
        return true;
      }
      if (due > AppConstant.ACTIVITY_TIME_OUT) {
        return true;
      }
      return false;
    }

    activityTimes(): void {
      if (!this.authService.isAuthenticated()) {
        return;
      }
      const activity = {
        lastActivity: this.currentTime,
      };
      localStorage.setItem('activityLog', JSON.stringify(activity));
    }

    get currentTime(): number {
      const d = new Date();
      return d.getTime();
    }

}
